import React from "react"
import webify from "../util/webify"

interface LabelProps {
  label: string
  htmlFor?: string
  error?: string
  required?: boolean
}

const Label = (props: LabelProps) => {
  const { htmlFor, label, error, required } = props
  if (error) {
    return (
      <div className="label-component with-errors fg-red-700 text-sm font-semibold rounded-t-md pl-2 py-1">
        <label htmlFor={htmlFor}>{label}</label> <span>{error}</span>
      </div>
    )
  } else {
    return (
      <div className="label-component">
        <div className="label-styled">
          <label htmlFor={htmlFor}>{label}</label>
          {required && <span className="text-xl leading-none ml-px">*</span>}
        </div>
      </div>
    )
  }
}

export default Label
webify("gc-label", Label)
